const PAYMENT_RESUME_PREFIX = "guest-payment-resume-v1";

export const PAYMENT_FLOW_ARRIVAL = "arrival";
export const PAYMENT_FLOW_DEPARTURE = "departure";

const environmentScope = () => {
  if (typeof window === "undefined") return "unknown";
  const apiEnvironment = process.env.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || "unconfigured";
  return `${window.location.origin}|${apiEnvironment}`;
};

const resumeKey = (reservationCode) =>
  `${PAYMENT_RESUME_PREFIX}:${environmentScope()}:${encodeURIComponent(String(reservationCode || "").trim())}`;

export const getJourneyReservationCode = (data = {}) =>
  String(
    data.reservation_id ||
    data.reservationId ||
    data.reservation?.reservation_number ||
    data.reservation?.reservationId ||
    data.reservation?.id ||
    ""
  ).trim();

export const inferPaymentFlow = (data = {}) => {
  const session = data.checkout_session || data.checkoutSession || {};
  const selectedAction = session.selected_action || session.selectedAction;
  const onlineCheckin = data.online_checkin || data.onlineCheckin || {};

  if (selectedAction || String(onlineCheckin.status || "").toUpperCase() === "CHECKED_IN") {
    return PAYMENT_FLOW_DEPARTURE;
  }

  return PAYMENT_FLOW_ARRIVAL;
};

export const readPaymentResume = (reservationCode) => {
  if (!reservationCode) return null;
  try {
    const context = JSON.parse(sessionStorage.getItem(resumeKey(reservationCode)) || "null");
    if (!context || context.reservationCode !== reservationCode || context.environment !== environmentScope()) {
      return null;
    }
    return context;
  } catch {
    return null;
  }
};

export const savePaymentResume = (reservationCode, next = {}) => {
  if (!reservationCode) return null;
  const current = readPaymentResume(reservationCode) || {};
  const context = {
    reservationCode,
    environment: environmentScope(),
    flow: next.flow || current.flow || PAYMENT_FLOW_ARRIVAL,
    step: next.step || current.step || "payment",
    selectedAction: next.selectedAction || current.selectedAction || "",
    pending: next.pending !== undefined ? Boolean(next.pending) : current.pending !== false,
    settled: next.settled !== undefined ? Boolean(next.settled) : current.settled === true,
    returnedFromProvider: next.returnedFromProvider !== undefined
      ? Boolean(next.returnedFromProvider)
      : current.returnedFromProvider === true,
    startedAt: Number.isFinite(Number(next.startedAt)) ? Number(next.startedAt) : Number(current.startedAt) || 0,
    attempts: Number.isFinite(Number(next.attempts)) ? Number(next.attempts) : Number(current.attempts) || 0,
  };
  sessionStorage.setItem(resumeKey(reservationCode), JSON.stringify(context));
  return context;
};

export const clearPaymentResume = (reservationCode) => {
  if (reservationCode) sessionStorage.removeItem(resumeKey(reservationCode));
};

export const capturePaymentReturnIntent = () => {
  const url = new URL(window.location.href);
  const isPaymentReturn = url.searchParams.get("payment_return") === "1";
  if (!isPaymentReturn) return false;

  url.searchParams.delete("payment_return");
  const search = url.searchParams.toString();
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${search ? `?${search}` : ""}${url.hash}`
  );
  return true;
};
